import React from 'react';
import { useMediaQuery } from 'react-responsive';

import Carousel from './Carousel';
import DesktopGallery from './DesktopGallery';
import Notice from '../Notice';
import UpgradeButton from '../UpgradeButton';
import './styles.css';
import { Plans } from '../../constants';

const Customize = ({ onClickUpgrade, getCouponContentKey }) => {
  const isMobile = useMediaQuery({
    query: '(max-width: 768px)',
  });
  return (
    <section id="customize-select-section">
      <header className="select-header">Customize More with Annual Membership</header>
      <span className="select-text__md">Annual members get early customization and more options to customize</span>
      {isMobile ? <Carousel /> : <DesktopGallery />}
      <div>
        <p className="customize-winter select-text__md">
          The next box will offer incredible customization options for Annual Members.
          <br />
          Don’t miss out on these additional choices.
        </p>
        <Notice getCouponContentKey={getCouponContentKey} />
        <UpgradeButton onClickUpgrade={() => onClickUpgrade(Plans.ANNUAL)} getCouponContentKey={getCouponContentKey} />
        <div className="select-text__sm select-options">*Number of options varies based on season.</div>
      </div>
    </section>
  );
};

export default Customize;
